/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Point } from './point';

export type ExtrasWeekly = Point[] | null;
